import { HTTP } from './helpers/http.js'

export default {
  add (organizationId, modelName, modelId) {
    const url = `/api/v1/organizations/${organizationId}/${modelName}/${modelId}/like`
    return HTTP.post(url)
  },

  remove (organizationId, modelName, modelId) {
    const url = `/api/v1/organizations/${organizationId}/${modelName}/${modelId}/unlike`
    return HTTP.post(url)
  },
}
